import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, cloneElement, isValidElement } from 'react';
import { tooltipClass } from './styles';
import { scrollConsumer } from '../Scroll/context';
import { getUidStr } from '../utils/uid';
import { getPosition as _getPosition } from '../utils/dom/popover';
var DefaultProps = {
  animation: true,
  delay: 0,
  position: 'top',
  trigger: 'hover'
};
export default function (options) {
  var show = options.show,
      hide = options.hide,
      move = options.move,
      isCurrent = options.isCurrent;

  var Container =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Container, _PureComponent);

    var _super = _createSuper2(Container);

    function Container(props) {
      var _this;

      _classCallCheck(this, Container);

      _this = _super.call(this, props);
      _this.id = void 0;
      _this.placeholderElement = void 0;
      _this.showTimer = void 0;
      _this.handleShow = _this.handleShow.bind(_assertThisInitialized(_this));
      _this.handleDismiss = _this.handleDismiss.bind(_assertThisInitialized(_this));
      _this.tryHide = _this.tryHide.bind(_assertThisInitialized(_this));
      _this.elementRef = _this.elementRef.bind(_assertThisInitialized(_this));
      _this.id = getUidStr();
      return _this;
    }

    _createClass(Container, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!move || !isCurrent(this.id)) return;
        var _this$props = this.props,
            scrollLeft = _this$props.scrollLeft,
            scrollTop = _this$props.scrollTop;

        if (prevProps.scrollLeft !== scrollLeft || prevProps.scrollTop !== scrollTop) {
          var pos = this.getPosition();
          move(this.id, pos);
          this.tryHide();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        hide();
      }
    }, {
      key: "getElement",
      value: function getElement() {
        return this.placeholderElement.nextSibling;
      }
    }, {
      key: "getPosition",
      value: function getPosition() {
        var _this$props$position = this.props.position,
            position = _this$props$position === void 0 ? DefaultProps.position : _this$props$position;
        var el = this.getElement();
        return _getPosition(position, el);
      }
    }, {
      key: "elementRef",
      value: function elementRef(el) {
        this.placeholderElement = el;
      }
    }, {
      key: "tryHide",
      value: function tryHide() {
        var scrollElement = this.props.scrollElement;
        var rect = this.getElement().getBoundingClientRect();
        var scrollRect = scrollElement ? scrollElement.getBoundingClientRect() : {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        };

        if (rect.bottom < scrollRect.top || rect.top > scrollRect.bottom || rect.right < scrollRect.left || rect.left > scrollRect.right) {
          hide();
        }
      }
    }, {
      key: "handleShow",
      value: function handleShow() {
        var _this2 = this;

        if (this.showTimer) clearTimeout(this.showTimer);
        var delay = this.props.delay;

        if (!delay) {
          this.showSync();
        } else {
          this.showTimer = setTimeout(function () {
            _this2.showSync();
          }, delay);
        }
      }
    }, {
      key: "handleDismiss",
      value: function handleDismiss() {
        clearTimeout(this.showTimer);
        hide();
      }
    }, {
      key: "showSync",
      value: function showSync() {
        var pos = this.getPosition();
        var style = Object.keys(pos).reduce(function (data, key) {
          data[key] = pos[key];
          return data;
        }, {});
        var props = Object.assign({}, this.props, {
          style: style
        });
        show(props, this.id, this.props.style);
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var _this$props2 = this.props,
            children = _this$props2.children,
            trigger = _this$props2.trigger,
            disabledChild = _this$props2.disabledChild,
            tip = _this$props2.tip;

        if (!
        /*#__PURE__*/
        isValidElement(children)) {
          console.error(new Error('Tooltip children expect a single ReactElement.'));
          return null;
        }

        if (!tip) return children;
        var inner = disabledChild ?
        /*#__PURE__*/
        React.createElement("span", {
          className: tooltipClass('disabled-wrapper'),
          style: {
            cursor: 'not-allowed'
          }
        },
        /*#__PURE__*/
        cloneElement(children, {
          style: _objectSpread2(_objectSpread2({}, children.props.style), {}, {
            pointerEvents: 'none'
          })
        })) : children;
        var props = {
          key: 'el'
        };

        if (trigger === 'hover') {
          props.onMouseEnter = this.handleShow;
          props.onMouseLeave = this.handleDismiss;
        } else {
          props.onClick = function (e) {
            if (e) e.stopPropagation();
            setTimeout(_this3.handleShow, 10);
            if (children.props.onClick) children.props.onClick();
          };
        }

        return [
        /*#__PURE__*/
        React.createElement("noscript", {
          ref: this.elementRef,
          key: "ns"
        }),
        /*#__PURE__*/
        cloneElement(inner, props)];
      }
    }]);

    return Container;
  }(PureComponent);

  Container.defaultProps = DefaultProps;
  return scrollConsumer(Container);
}